import { DOCUMENT_CANCEL, DOCUMENT_SIGN } from '@/constants/api';
import { Documents } from '@/types/company';
import { request } from '@/utils/request';
import { REQUEST_METHOD } from '@treyd-io/core/constants/request';

export const cancelDocumentSigning = ({ documentId }: { documentId: number }) =>
  request({
    url: DOCUMENT_CANCEL(documentId),
    method: REQUEST_METHOD.POST,
  });

export const signDocument = ({
  documentId,
  data,
}: Documents.SignDocumentPayload) =>
  request({
    url: DOCUMENT_SIGN(documentId),
    method: REQUEST_METHOD.POST,
    data,
  });

export {
  getBankAccountStatementsLetter,
  getDocumentById,
  getGlobalAccountStatementLetter,
} from '@treyd-io/shared/apis/documents';
